<template>
  <div class="resultPage">
    <div class="background"></div>
    <div class="resultMessage">
      <h1>{{ t("testResult") }}</h1>
      <!-- <img class="passImage" src="@/assets/green-check.png" /> -->
      <div class="wrap">
        <div class="scoreBox" v-if="result >= 80">
          <h2>
            {{ t("messagePass") }}
            {{ result }}% !
          </h2>
          <img class="finalImage" src="@/assets/pass.png">
          <h2>{{ t("reviewPass") }}</h2>
        </div>

        <div class="scoreBox" v-if="result < 80">
          <h2>
            {{ t("messageFail") }}
            {{ result }}% !
          </h2>
          <img class="finalImage" src="@/assets/fail.png">
          <h2>{{ t("reviewFail") }}</h2>
        </div>

        <button class="smallButton" @click="goToSources">
          <h4>{{ t("sources") }}</h4>
        </button>

        <div class="studentAnswers">
          <ul>
            <li
              v-for="(studentAnswer, index) in studentAnswers"
              :key="studentAnswer"
              :class="{
                wrong: wrongAnswer(valuations, index),
              }"
            >
              <p class="task">
                {{ t("task") }} {{ index + 1 }}:
                <span>{{ testItems[index].task }}</span>
              </p>
              <p v-if="!wrongAnswer(valuations, index)" class="answer">
                {{ t("yourAnswer") }} "{{ studentAnswers[index] }}" is
                {{ t("correct") }}!
              </p>
              <p v-else class="answer">
                {{ t("yourAnswer") }} "{{ studentAnswers[index] }}" is
                {{ t("wrong") }}!
              </p>
            </li>
          </ul>
        </div>
      </div>
      <button class="largeButton" @click="goToCourses">{{ t("courses") }}</button>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },
  computed: {
    testItems() {
      return this.$store.state.testItems;
    },
    valuations() {
      return this.$store.state.valuations;
    },
    result() {
      return this.$store.state.score;
    },
    studentAnswers() {
      return this.$store.state.studentAnswers;
    }
  },

  methods: {
    wrongAnswer(array1, i) {
      let isWrong = false;
      if (array1[i] == "Wrong") {
        isWrong = true;
      }
      return isWrong;
    },

    goToCourses() {
      this.$router.replace({ name: "courses" });
    },
    goToSources() {
      this.$router.push({ name: "sources" });
    }
  }
};
</script>
<i18n>
{
  "en-GB": {
    "testResult":"Test result",
    "messagePass": "Congratulations you passed this exam, your result is:",
    "messageFail": "We are sorry, you failed this test, your result is:",
    "reviewPass": "Please review your answers.",
    "reviewFail": "Please review your answers and try again.",
    "task": "Task",
    "yourAnswer":"Your answer ",
    "correct":"correct",
    "wrong":"wrong",
    "courses":"Courses",
    "sources":"Sources"
  },
  "nl-NL": {
    "testResult":"Testresultaat:",
    "messagePass": "Gefeliciteerd, je hebt deze test gehaald, je resultaat is:",
    "messageFail": "Helaas, je hebt deze test niet gehaald, je resultaat is:",
    "reviewPass": "Herzie alstublieft uw antwoorden",
    "reviewFail": "Herzie alstublieft uw antwoorden en probeer opnieuw.",
    "task": "Taak",
    "yourAnswer":"Uw antwoord ",
    "correct":"juist",
    "wrong":"verkeerd",
    "courses":"Curssusen",
    "sources":"Bronnen"
  }
}
</i18n>

<style scoped>
.resultPage {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.background {
  background-image: url("https://phoenix-engineering.be/wp-content/uploads/2019/07/shutterstock_1113165392.png");
  background-size: cover;
  background-position: unset;
  background-repeat: no-repeat;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: blur(3px);
  -webkit-filter: blur(3px);
  z-index: -1;
}
.resultMessage {
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  background-color: rgb(41, 41, 42);
  border: 30px solid rgb(41, 41, 42);
  width: 85%;
  box-shadow: 0 0px 5px 0px rgb(114, 108, 109);
}
h1 {
  font-size: 37px;
  color: white;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1.5px;

  margin: 0;
  margin-bottom: 30px;
  padding: 20px;
}

.wrap {
  border: 30px solid rgb(87, 87, 87);
  background-color: rgb(87, 87, 87);
  position: relative;
}

.scoreBox {
  border-bottom: 30px solid rgb(87, 87, 87);
}

h2 {
  color: white;
  text-align: center;
  padding: 20px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.studentAnswers {
  border-bottom: 0px;
  text-align: left;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
li {
  font-size: 18px;
  background-color: rgb(176, 230, 163);
  border-bottom: solid 25px rgb(87, 87, 87);
  padding: 30px;
}

.task {
  margin-top: 0;
  margin-bottom: 0px;
  font-weight: bold;
}
.answer {
  margin-top: 35px;
  margin-bottom: 0px;
}

.wrong {
  background-color: rgba(255, 81, 81, 0.733);
}
span {
  font-weight: normal;
}
.finalImage {
  width: 100px;
  height: 100px;
  margin: 0;
}
.largeButton {
  font-family: "Raleway", sans-serif;
  letter-spacing: 1.5px;

  margin-top: 60px;
  margin-bottom: 30px;
  padding: 30px 45px;
  background-color: rgb(165, 0, 41);

  border-style: none;
  color: rgb(255, 255, 255);

  font-size: 18px;
  cursor: pointer;
}

.smallButton {
  margin: 0px;
  padding: 15px 25px;

  font-family: "Raleway", sans-serif;

  background-color: rgb(165, 0, 41);
  border-style: none;
  color: rgb(255, 255, 255);

  font-size: 15px;
  cursor: pointer;

  position: absolute;
  top: 0;
  right: 0;
}

.smallButton h4 {
  margin: 0px;
}

button:hover {
  transform: scale(1.03);
}

@media screen and (max-width: 1400px) {
  h1 {
    font-size: 34px;
  }

  h2 {
    padding: 16px;
    font-size: 22px;
  }

  .finalImage {
    width: 80px;
    height: 80px;
    margin: 0;
  }
}

@media screen and (max-width: 1200px) {
  h1 {
    font-size: 34px;
  }

  h2 {
    font-size: 22px;
  }

  .smallButton {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 35px;
    padding: 15px 25px;
    position: relative;
  }
}

@media screen and (max-width: 600px) {
  .resultMessage {
    margin: 0px;
    width: 100%;
    border: 0px solid;
  }

  h1 {
    font-size: 30px;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .wrap {
    border-width: 20px;
  }

  .scoreBox {
    border-bottom: 0px;
  }

  h2 {
    font-size: 18px;
    padding: 18px;
  }

  li {
    padding: 20px;
    border-bottom-width: 20px;
  }

  .studentAnswers {
    border-bottom: 0px;
    text-align: left;
  }

  .finalImage {
    width: 60px;
    height: 60px;
    margin: 0;
  }

  .smallButton {
    margin-top: 7px;
    margin-bottom: 25px;
    padding: 13px 20px;
    font-size: 12px;
  }

  span {
    font-size: 15px;
  }

  .task {
    font-size: 15px;
  }

  .answer {
    font-size: 15px;
  }

  .largeButton {
    padding: 20px 35px;
    font-size: 15px;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
</style>
